module.exports = __webpack_public_path__ + "media/tip.53a3aff4.wav";